import useClarity from '@hooks/thirdPartyServices/useClarity';
import { type FC } from 'react';
import useSentry from '../hooks/thirdPartyServices/useSentry';

const ThirdPartyServicesEnabledProvider: FC<React.PropsWithChildren<{}>> = ({
    children,
}) => {
    useSentry();
    useClarity();

    return <>{children}</>;
};

interface ThirdPartyServicesProviderProps {
    enabled?: boolean;
}

const ThirdPartyServicesProvider: FC<
    React.PropsWithChildren<ThirdPartyServicesProviderProps>
> = ({ children, enabled }) => {
    if (enabled) {
        return (
            <ThirdPartyServicesEnabledProvider>
                {children}
            </ThirdPartyServicesEnabledProvider>
        );
    }
    return <>{children}</>;
};

export default ThirdPartyServicesProvider;
